module.exports = __webpack_public_path__ + "img/deploy_infra.c8af3732.svg";